async function getTerminalAPI() {
  const result = await window.fetch('/webapi/timeslots/api/v1/terminal', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return result;
}

export default getTerminalAPI;
